import React, { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { baseUrl, CalendlyPop, GET_NETWORK_ICON } from "../../../../../utils";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

function PricingTabEvent({ day, desc, listFeatureList, planId, planName, planPrice,userData, planMonthlyDataProductID, planYearlyDataProductID, plan, handleCheckout, isPlanActive, onClickToNavigate, setOneDayPlan }) {
   const [loading, setLoading] = useState(false);
   const [talkshow, talksetShow] = useState(false);
   const isNewUser = true

    const ownerId = localStorage.getItem('ownerId');
    const HL_PLAN = planName == "Monthly Pass"
    return <div className={`price_counter price_card_wrap price_meter ${HL_PLAN ? "highlightCard" : ""}`} key={planId}>
        <div className="price_card">
            <h3 className="color1 text-uppercase">{planName}</h3>
            <div className="price_card_inner">
                <p className="color2 f2">{desc}</p>

              { !isNewUser ?  
                    
                <div className="price_wrap">
                    {planPrice === 0 || planPrice === "" ? (
                        <h2 className={HL_PLAN ? "text-gradient" : ""}>
                            <span
                                style={{ display: "none" }}
                                className="price odometer count"
                                data-price-monthly="0"
                                data-price-yearly="0"
                                data-product-monthly="10081"
                                data-product-yearly="10081"
                            >
                                0
                            </span>
                            <span className="price count">{planPrice === 0 ? "FREE" : day}</span>
                        </h2>
                    ) : (
                        <h2 className={HL_PLAN ? "text-gradient" : ""}>
                            <sup className={HL_PLAN ? "text-gradient" : ""}>$</sup>
                            <span className="price odometer count" data-price- ={planPrice} data-price-yearly={planPrice} data-product-monthly={planMonthlyDataProductID} data-product-yearly={planYearlyDataProductID}>
                                {planPrice}
                            </span>
                            <span className={`valid_from color2 ${HL_PLAN ? "text-gradient" : ""}`}>/{day}</span>
                        </h2>
                    )}
                </div> : <>
 
                {  talkshow ? <CalendlyPop show={talkshow} hidePop={()=>talksetShow(false)} url={'https://calendly.com/taggbox/demo?embed_domain=app.socialwalls.com&embed_type=PopupText'} /> : null }
                  <div className="price_btn">
                    <Button variant={ownerId == 154370 ? planName.includes('ENTERPRISE') ? 'primary' : ' outline-dark' : isPlanActive(planId) ? 'primary ' : 'outline-dark'} id={`tb_${String(planName).toLocaleLowerCase()}`}
                     name="planName" value={planId} data-price={planPrice} data-product="10088" data-name={String(planName).toLowerCase()} 
                     className={`btn-hover-primary w-100 ${loading ? 'spinner spinner-right disabled' : ''}`} 
                     onClick={isPlanActive(planId) ? null :  () => talksetShow(true) } style={{ marginTop : 0}}>
                        {`${isPlanActive(planId) ? "Current Plan" : planId == "" ? ownerId == 154370 ? planName.includes('ENTERPRISE') ? "Current Plan" : "Talk to Sales" : "Talk To Sales " : "Talk to Sales"} `}
                    </Button>
                </div>

                </>

              }
 

                <ul className="pricingList">
                    {listFeatureList &&
                        listFeatureList.map((feature, index) => {
                            const { name, value, description, networkList } = feature;
                            return (
                                <OverlayTrigger key={index} placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip className={networkList.length <= 0 ? 'dark' : 'light'}>
                                    {networkList.length <= 0 ? description
                                        :
                                        <ul className="platform__icons colored_social_icons">
                                            {networkList.map(({ name, icon, id }) => (
                                                <li key={id}>

                                                    {id === 1 ? <svg id="twitter" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 44.518 44.518">
                                                        <path id="Path_5" data-name="Path 5" d="M0,0H44.518V44.518H0Z" fill="none" />
                                                        <path id="Path_7" data-name="Path 7" d="M19.036,13.554,30.942,0H28.121L17.778,11.766,9.523,0H0L12.486,17.794,0,32.006H2.821L13.737,19.578l8.72,12.429H31.98Zm-3.865,4.4L13.9,16.177,3.838,2.083H8.172L16.3,13.462l1.262,1.773L28.12,30.025H23.786Zm0,0" transform="translate(6.313 6.281)" fill="#0f1419" />
                                                    </svg>
                                                        : <img alt={name} src={baseUrl(`icons/social-icons/${GET_NETWORK_ICON(id)}.svg`)} height="16" width="16" />}
                                                </li>
                                            ))}
                                        </ul>}
                                </Tooltip>}>
                                    <li>
                                        <span className="iconCheckClose">
                                            {value === 1 ? (
                                                <FontAwesomeIcon type={'solid'} icon={'circle-check'} iconClass={'text-success'} />
                                            ) : (
                                                <FontAwesomeIcon type={'solid'} icon={'circle-xmark'} iconClass={'text-danger'} />
                                            )}
                                        </span>
                                        {name} <FontAwesomeIcon type={'regular'} icon={'circle-info'} iconClass={'fs-6 text-gray-500'} />
                                    </li>
                                </OverlayTrigger>
                            );
                        })}
                </ul>

               {  !isNewUser ?
                  <div className="price_btn">
                    <Button variant={ownerId == 154370 ? planName.includes('ENTERPRISE') ? 'primary' : ' outline-dark' : isPlanActive(planId) ? 'primary ' : 'outline-dark'} id={`tb_${String(planName).toLocaleLowerCase()}`} name="planName" value={planId} data-price={planPrice} data-product="10088" data-name={String(planName).toLowerCase()} className={`btn-hover-primary w-100 ${loading ? 'spinner spinner-right disabled' : ''}`} onClick={planId == "" ? onClickToNavigate : [54].includes(planId) ? () => isPlanActive(planId) ? setOneDayPlan(false) : setOneDayPlan(true) : () => { setLoading(true); handleCheckout(plan, false, () => setLoading(false)) }}>{`${isPlanActive(planId) ? "Current Plan" : planId == "" ? ownerId == 154370 ? planName.includes('ENTERPRISE') ? "Current Plan" : "Select Plan" : "Talk To Sales " : "Select Plan"} `}</Button>
                </div> : null }
              
            </div>
        </div>
    </div>
}

export default PricingTabEvent;